var portfolioTransactionsList = {
	caption: "Transacciones del portafolio",
	date: "Fecha",
	time: "Hora",
	name: "Nombre",
	isin: "ISIN",
	transactionType: "Tipo",
	numberOfShares: "Cantidad/Nominal",
	executionPrice: "Precio de ejecución",
	executionValue: "Valor de ejecución",
	assetClass: "Clase de activos",
	actions: "Acciones",
	buy: "Comprar",
	sell: "Vender",
	cash: "Dinero en efectivo",
	payout: "Pagar",
	short: "Corto",
	cover: "Cubrir",
	noTransactions: "Sin transacciones",
	bond: "Bono",
	commodity: "Materia prima",
	currency: "Moneda",
	debt: "Deuda",
	etf: "Fondo cotizado",
	fund: "Fondo",
	generic: "Genérico",
	index: "Índice",
	stock: "Acciones",
	interestRate: "Tasa de interés",
	structuredProduct: "Producto estructurado",
	investmentProduct: "Producto de inversión",
	leveragedProduct: "Producto apalancado",
	option: "Opción",
	future: "Futuro"
};
var es = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { es as default, portfolioTransactionsList };
